<template>
    <v-card class="detail-card">
      <v-card-title>
        <h3>{{title}}</h3>
      </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="detailHeaders"
        :items="items"
        hide-actions
        class="elevation-1"
        item-key="id"
        no-data-text="No hay información que mostrar"
      >
      <template v-slot:items="props">
          <td class="text-xs-left">
            <router-link :to="routeLink(props.item)">{{ props.item.route_description }}</router-link>
          </td>
          <td ><v-icon color="red" @click="deleteItem(props.item)">delete_forever</v-icon></td>
          <td class="text-xs-rigth">{{ props.item.metal_quantity }}</td>
          <td class="text-xs-right">{{ props.item.metal_origin }}</td>
          <td class="text-xs-right">{{ props.item.metal_size }}</td>
          <td class="text-xs-right">{{ props.item.metal_content }}</td>
          <td class="text-xs-right">{{ props.item.metal_price }}</td>
          
      </template>
      <template slot="footer">
        <tr>
          <td><strong>Totales</strong></td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { PUOND_CONVERT } from '../../utils/constants';
export default {
  props: {
    items: Array,
    title: String,
    showOperations: {
      type: Boolean,
      default: true,
    },
    currentBag: {
      type: Object,
    },
  },
  data() {
    return {
      detailHeaders: [
        { text: 'Ruta', value: 'route_description'},
        { text: '', width: '1%', sortable: false },
        { text: 'Cantidad', value: 'metal_quantity', width: '1%' },
        { text: 'Origen', value: 'metal_origin', width: '1%' },
        { text: 'Tamaño', value: 'metal_size', width: '1%' },
        { text: 'Contenido', value: 'metal_content', width: '1%' },
        { text: 'Precio pagado', value: 'metal_price', width: '1%' },
      ],
    };
  },
  methods: {
    deleteItem(event) {
      this.$emit('deleteItem', event);
    },
    routeLink(row) {
      return `/bag/${this.currentBag.id}/route/${row.route_id}`;
    },
  },
  computed: {
    totals() {
      if (!this.items || this.items.length === 0) {
        return {
          weigth: 0,
          price_per_kilo: 0,
        };
      } else {

        const results = {
          weigth: 0,
          price_per_kilo: 0,

        };
        for (const line of this.items) {
          results.weigth += parseInt(line.weigth, 10);
          results.price_per_kilo += parseFloat(line.price_per_kilo);
        }
        return results;
      }
    },
    computedHeaders() {
      let results = this.detailHeaders;
      if (!this.showRoute) {
        results = results.filter((e) => {
          return e.text !== 'Ruta';
        });
      }
      return results;
    },
  },
};
</script>
